import React, {useState} from 'react';

import rtlService from '../../../../services/app/rtlService';
import {getLocalizedStrings} from '../../../../services/localization/localizationService';
import PauseModeImage from './PauseModeImage';
import PauseModeVideo from './PauseModeVideo';

const PauseModeSlide = (props) => {
    const {slideData, pauseModeData, isActiveSlide, onEnded} = props;
    const {title, description} = slideData || {};

    const thumbnail = pauseModeData.thumbnail || slideData.thumbnail;
    const video = pauseModeData.video || slideData.video;
    const image = pauseModeData.image || slideData.image;

    const [isVideoVisible, setIsVideoVisible] = useState(video);
    const localizedStrings = getLocalizedStrings();

    const onError = () => {
        setIsVideoVisible(false);
    };

    return (
        <div dir={rtlService.getDir()}>
            {isVideoVisible ? (
                <PauseModeVideo
                    onError={onError}
                    video={video}
                    thumbnail={thumbnail}
                    content={slideData}
                    isActiveSlide={isActiveSlide}
                    onEnded={onEnded}
                />
            ) : (
                <PauseModeImage image={image} />
            )}
            <h1 className='mt-4 text-24'>{localizedStrings[title]}</h1>
            <p className='mb-8 mt-4'>{localizedStrings[description]}</p>
        </div>
    );
};

export default PauseModeSlide;
